type TStateWithChecksums = {
	checksums: {
		is_pending: boolean,
		error: null | string,
		by_id: Object
	}
}
export const getChecksums = (state: TStateWithChecksums): Object => state.checksums.by_id;